import { render, staticRenderFns } from "./shipping-fulfillment.vue?vue&type=template&id=8ae6db84&scoped=true&"
import script from "./js/shipping-fulfillment.js?vue&type=script&lang=js&"
export * from "./js/shipping-fulfillment.js?vue&type=script&lang=js&"
import style0 from "./shipping-fulfillment.vue?vue&type=style&index=0&id=8ae6db84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae6db84",
  null
  
)

export default component.exports